import React, { CSSProperties, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectActiveCompanyId } from '@mm/state/selectors/viewSelectors';
import strategyRedLogo from 'assets/whitelabel-logos/strategy-red.png';
import { WhitelabelContext } from '@mm/hooks';
import { IS_PROD_URL } from '@mm/utils';

export const STRATEGY_RED_ID = 472201;

export const WhitelabelProvider = ({ children }) => {
  const selectedCompanyId = useSelector(selectActiveCompanyId);
  const companyIds = useMemo(
    () => (IS_PROD_URL ? [STRATEGY_RED_ID] : [4591]),
    [],
  );
  const primaryColor = '#F42626';

  const getWhitelableLogo = (src: string, width?: number) => (
    <img src={src} style={{ width }} />
  );

  const getCompanyConfig = useCallback(
    (customCompanyId?: number, companyHash?: string) => {
      const effectiveCompanyId = customCompanyId ?? selectedCompanyId;
      const isWhitelabel = companyIds.includes(effectiveCompanyId);

      const commonTextStyle: CSSProperties = {
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '22px',
      };

      switch (true) {
        case isWhitelabel || companyHash === 'strategyred':
          return {
            companyName: 'Strategy RED',
            pixelName: 'RED Eye',
            companyLogo: getWhitelableLogo(strategyRedLogo, 120),
            primaryColor,
            primaryButtonStyle: {
              background: '#F42626',
              border: `1px solid ${primaryColor}`,
              color: 'white',
              ...commonTextStyle,
            },
            secondaryButtonStyle: {
              border: `1px solid ${primaryColor}`,
              color: primaryColor,
            },
            isWhitelabelCompany: true,
            supportEmail: 'zach@strategyredsports.com',
            companyHash: 'strategyred',
          };
        default:
          return {};
      }
    },
    [selectedCompanyId, companyIds],
  );

  const config = useMemo(
    () => getCompanyConfig(),

    [getCompanyConfig],
  );

  const providerValue = useMemo(
    () => ({ ...config, getCompanyConfig }),
    [config, getCompanyConfig],
  );

  return (
    <WhitelabelContext.Provider value={providerValue}>
      {children}
    </WhitelabelContext.Provider>
  );
};
